import {Injectable} from '@angular/core';
import {take} from 'rxjs';
import { TransactionsMsService } from '../dashboard/bankAccounts/transactions-ms.service';
import { TransactionNoteDto } from '../dashboard/bankAccounts/models/transactionNoteDto.model';
import { TransactionsDto } from '../dashboard/bankAccounts/models/transactionsDto.model';

@Injectable({
  providedIn: 'root'
})
export class TransactionNotesService {

  constructor(private transactionsMsService: TransactionsMsService) { }

  deleteNote(transaction: TransactionsDto) {
    transaction.loading = true;
    this.transactionsMsService.deleteTransactionNotes(transaction.note.id)
      .pipe(take(1))
      .subscribe(_ => {
        transaction.inputNotes = null;
        transaction.note = null;
        transaction.loading = false;
      });
  }

  saveNotesField(transaction: TransactionsDto) {

    if (!transaction.inputNotes) {
      return;
    }

    transaction.loading = true;
    transaction.showDiv = false;
    transaction.showEdit = true;

    const transactionNotes = new TransactionNoteDto();
    transactionNotes.resourceId = transaction.resourceId;
    transactionNotes.notes = transaction.inputNotes;

    if (!!transaction.note?.id) {
      transactionNotes.id = transaction.note?.id;
      this.transactionsMsService.updateTransactionNotes(transactionNotes)
        .pipe(take(1))
        .subscribe((val) => {
          transaction.note = val;
          transaction.loading = false;
        });
    }
    else {
      this.transactionsMsService.createTransactionNotes(transactionNotes)
        .pipe(take(1))
        .subscribe((val) => {
          transaction.note = val;
          transaction.loading = false;
        });
    }
  }

  editTransactionNote(transaction: TransactionsDto) {
    transaction.inputNotes = transaction.note?.notes;
    transaction.showDiv = true;
    transaction.showEdit = false;
  }

  cancelTransactionNote(transaction: TransactionsDto) {
    transaction.inputNotes = null;
    transaction.showEdit = true;
    transaction.showDiv = false
  }
}
